import React from "react";
import PropTypes from 'prop-types'
import Slider from "react-slick";
class SimpleSlider extends React.Component {
  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 400,
      autoplay:true,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
            <Slider {...settings}>
                {
                    this.props.bannerBgimgUrl.map(function(item,index){
                       return (
                        <div key = {index}>
                            <div className='banner' style={item}></div>
                        </div>
                       ) 
                    })
                }
                
            </Slider>
      
    );
  }
}


SimpleSlider.proptypes = {
    bannerBgimgUrl:PropTypes.array
}
export default SimpleSlider;


// WEBPACK FOOTER //
// ./src/components/slider/index.js